import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import styles from './LoginPage.module.css';

export function LoginPage() {
  const { signInWithGoogle, loading, error, firebaseUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (firebaseUser) navigate({ to: '/dashboard' });
  }, [firebaseUser, navigate]);

  return (
    <div className={styles.root}>
      {/* Background glow orbs */}
      <div className={styles.orb1} />
      <div className={styles.orb2} />

      <div className={styles.card}>
        {/* Logo */}
        <div className={styles.logoWrap}>
          <div className={styles.logoMark}>
            <svg viewBox="0 0 40 40" fill="none">
              <defs>
                <linearGradient id="lg" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stopColor="#6366F1"/>
                  <stop offset="100%" stopColor="#22D3EE"/>
                </linearGradient>
              </defs>
              <rect width="40" height="40" rx="12" fill="url(#lg)"/>
              <text x="20" y="27" fontFamily="sans-serif" fontSize="18" fontWeight="700"
                    textAnchor="middle" fill="white">e</text>
            </svg>
          </div>
          <h1 className={styles.wordmark}>enska.ai</h1>
        </div>

        <h2 className={styles.heading}>Welcome back</h2>
        <p className={styles.subheading}>
          Sign in to the enska.ai platform portal
        </p>

        {error && (
          <div className={styles.errorBanner}>
            {error}
          </div>
        )}

        <button
          id="google-signin-btn"
          className={styles.googleBtn}
          onClick={signInWithGoogle}
          disabled={loading}
        >
          {loading ? (
            <span className={styles.btnSpinner} />
          ) : (
            <GoogleIcon />
          )}
          {loading ? 'Signing in…' : 'Continue with Google'}
        </button>

        <p className={styles.disclaimer}>
          Access is restricted to authorised enska.ai platform users.
          <br />
          Contact <a href="mailto:platform@enska.ai">platform@enska.ai</a> for access.
        </p>
      </div>

      <p className={styles.copyright}>
        © {new Date().getFullYear()} enska.ai · All rights reserved
      </p>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18">
      <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"/>
      <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z"/>
      <path fill="#FBBC05" d="M3.964 10.71c-.18-.54-.282-1.117-.282-1.71s.102-1.17.282-1.71V4.958H.957C.347 6.173 0 7.548 0 9s.348 2.827.957 4.042l3.007-2.332z"/>
      <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.958L3.964 6.29C4.672 4.163 6.656 3.58 9 3.58z"/>
    </svg>
  );
}
